// Material.js - YOUR ORIGINAL CODE + ONLY ONE FIX
import React, { useState, useEffect } from 'react';
import { Box, TextField, Button, IconButton, Typography } from '@mui/material';
import { Delete } from '@mui/icons-material';

const defaultMaterials = [
  { name: "Cell", make: "", origin: "", description: "" },
  { name: "Glass(Front)", make: "", origin: "", description: "" },
  { name: "Glass(Back)", make: "", origin: "", description: "" },
  { name: "Encapsulant(Front)", make: "", origin: "", description: "" },
  { name: "Encapsulant(Back)", make: "", origin: "", description: "" },
  { name: "Flux", make: "", origin: "", description: "" },
  { name: "Interconnector", make: "", origin: "", description: "" },
  { name: "String Connector", make: "", origin: "", description: "" },
  { name: "Cell Fixing Tape", make: "", origin: "", description: "" },
  { name: "Frame", make: "", origin: "", description: "" },
  { name: "Junction Box", make: "", origin: "", description: "" },
  { name: "Adhesive(Sealant)", make: "", origin: "", description: "" },
  { name: "Potting Material", make: "", origin: "", description: "" },
  { name: "PV Connector", make: "", origin: "", description: "" },
];

const Material = ({ materials = [], onMaterialsChange }) => {
  const [localMaterials, setLocalMaterials] = useState(() => 
    JSON.parse(JSON.stringify(materials.length > 0 ? materials : defaultMaterials))
  );

  // THIS IS THE ONLY FIX — Sync when parent sends new materials (on edit)
  useEffect(() => {
    if (materials && materials.length > 0) {
      setLocalMaterials(JSON.parse(JSON.stringify(materials)));
    } else {
      setLocalMaterials(JSON.parse(JSON.stringify(defaultMaterials)));
    }
  }, [materials]); // ← This runs when StepThree passes new materials

  // Send back to parent
  useEffect(() => {
    onMaterialsChange(localMaterials);
  }, [localMaterials, onMaterialsChange]);

  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const updated = [...localMaterials];
    updated[index][name] = value;
    setLocalMaterials(updated);
  };

  const handleRemoveMaterial = (index) => {
    setLocalMaterials(prev => prev.filter((_, i) => i !== index));
  };

  const handleAddMaterial = () => {
    setLocalMaterials(prev => [...prev, { name: "", make: "", origin: "", description: "" }]);
  };

  return (
    <div>
      {localMaterials.map((material, index) => (
        <Box key={index} mb={4} p={2} border="1px solid #ccc" borderRadius="8px">
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" gutterBottom>
              {material.name || `Material ${index + 1}`}
            </Typography>
            <IconButton onClick={() => handleRemoveMaterial(index)}>
              <Delete />
            </IconButton>
          </Box>
          <Box display="grid" gridTemplateColumns="repeat(2, 1fr)" gap={2}>
            <TextField label="Material Name" name="name" value={material.name} onChange={(e) => handleInputChange(index, e)} fullWidth />
            <TextField label="Make" name="make" value={material.make} onChange={(e) => handleInputChange(index, e)} fullWidth />
            <TextField label="Origin" name="origin" value={material.origin} onChange={(e) => handleInputChange(index, e)} fullWidth />
            <TextField label="Description" name="description" value={material.description} onChange={(e) => handleInputChange(index, e)} fullWidth inputProps={{ maxLength: 500 }} />
          </Box>
        </Box>
      ))}
      <Button variant="contained" sx={{backgroundColor: '#111827', color: '#ffffff', '&:hover': {backgroundColor: '#111400'}}} onClick={handleAddMaterial}>
        Add Material
      </Button>
    </div>
  );
};

export default Material;